import { MAX_LENGTH_4000, MAX_LENGTH_50 } from 'Models/Constants';
import * as yup from 'yup';

export const CreateFoodCategorySchema = yup.object({
    name: yup.string().required('Errors.required').max(MAX_LENGTH_50, 'Errors.length_50'),
    description: yup.string().max(MAX_LENGTH_4000, 'Errors.length_4000')
});
